import { IS_EVIDENCE_ONLY_REFERRAL_ENABLED } from '@/app-shell/flags/evidence-flags';
import { useIsFreeUser } from '@heidi/commerce/data';
import { useEvidenceBillingInfo } from './useEvidenceBillingInfo';

/**
 * Hook to check if user is an Evidence-only subscriber.
 * Evidence-only means they have a PAID Evidence Pro subscription but no Scribe subscription.
 * Free trial users are excluded - the $25 referral is only for paying Evidence subscribers.
 *
 * Returns true only when:
 * 1. The feature flag 'release-evidence-only-referral' is enabled
 * 2. User has active paid Evidence Pro subscription (not free trial)
 * 3. User does not have an active Scribe subscription
 */
export function useIsEvidenceOnlyUser() {
  const { isFreeUser } = useIsFreeUser();
  const { hasEvidencePro, isInFreeTrial } = useEvidenceBillingInfo();

  const isFeatureEnabled = IS_EVIDENCE_ONLY_REFERRAL_ENABLED();
  const isPaidEvidenceOnly = isFreeUser && hasEvidencePro && !isInFreeTrial;

  return {
    isEvidenceOnlyUser: isFeatureEnabled && isPaidEvidenceOnly,
  };
}
